(function () {
  var section = document.getElementById('lwCompare');
  if (!section) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var prices = section.querySelectorAll('.lw-price');
  var reveal = section.querySelectorAll('.lw-card, .lw-save');

  function fmt(n) {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '\u00a0kr.';
  }

  function countUp(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (isNaN(target)) return;
    if (reduce) {
      el.textContent = fmt(target);
      return;
    }
    var start = null;
    var dur = 900;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var fired = false;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !fired) {
          fired = true;
          reveal.forEach(function (el) {
            el.classList.add('visible');
          });
          prices.forEach(countUp);
          io.disconnect();
        }
      });
    },
    { threshold: 0.25 }
  );
  io.observe(section);
})();
